export default __webpack_public_path__ + "assets/images/5db093bef66f3a2041bd157e84e40db4.png";